import { orderDomainStore } from '../../store';
export const getOrderVoucherRedemptionDetails = (voucherId) => {
    const details = orderDomainStore.data.orderVoucherRedemptionDetailsById[voucherId];
    if (!details) {
        throw new Error(`Cannot find redemption details for order voucher with ID: '${voucherId}'.`);
    }
    return details;
};
//# sourceMappingURL=get-order-voucher-redemption-details.js.map